import { useEffect, useState, useMemo, useContext } from 'react'
import { GenerateContext } from '@utils/GenerateContext'
import { IMAGE_TYPE } from "@utils/CONST"
import API from '@api/api'
import styles from './index.module.scss'

export default function SceneSwitchTab (props) {
    const {
        imageType,
        setBgImage,
        isCustomScene,
        setIsCustomScene
    } = useContext(GenerateContext)

    const customSceneAvailable = useMemo(() => {
        if (imageType == IMAGE_TYPE.COMMODITY) return true
        if (imageType == IMAGE_TYPE.MODEL) return true
        else {
            return API.url != 'https://photostudio.arcsoft.com.cn' && API.url != 'http://canary.ps.arcsoftbiz.com'
        }
    }, [imageType])

    useEffect(() => {
        if (isCustomScene) setBgImage()
    }, [isCustomScene])

    return (
        <div className={`${styles.SelectScene} ${isCustomScene? styles.scene_change_tab_l: styles.scene_change_tab_r}`} >
            <p className={`${styles.scene_change_tab}`}>
                <span onClick={() => setIsCustomScene(false)}>预设场景</span>
                <span
                    className={!customSceneAvailable ? styles.showIcon : null}
                    onClick={customSceneAvailable ? () => setIsCustomScene(true): () => {}}
                >
                    自定义场景
                </span>
            </p>
            <div style={{width: '100%'}}>
            {
                isCustomScene ?
                props.rightContent :
                props.leftContent                
            }
            </div>
        </div>
        
    )
}